import { Box } from "@mantine/core";
import Link from "next/link";
import { Dispatch, SetStateAction } from "react";
import BurgerModule from "../../header/Burger";
import Logo from "./Logo";
import LogoText from "./LogoText";

export default function LogoLayout({
  opened,
  setOpened,
  setCurrentPage,
}: {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  setCurrentPage?: Dispatch<SetStateAction<string>>;
}) {
  return (
    <Box
      style={{
        paddingLeft: "var(--mantine-spacing-sm)",
        paddingRight: "var(--mantine-spacing-sm)",
        display: "grid",
        gridTemplateColumns: "1fr auto 1fr",
        alignItems: "center",
      }}
    >
      <BurgerModule opened={opened} setOpened={setOpened} />
      <Link
        href={"/"}
        onClick={() => {
          setCurrentPage?.("");
          opened && setOpened(false);
        }}
        style={{
          gridColumn: 2,
          cursor: "pointer",
          textDecoration: "none",
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "center",
          flexGrow: 1,
          justifyItems: "center",
        }}
      >
        <Logo size={34} />
        <LogoText />
      </Link>
    </Box>
  );
}
